import { UnavailableEvent } from "@hubcapp/graphql";

import { endOfDay, isEqual, startOfDay } from "date-fns";

export const isEventAllDay = ({
  startDateTime,
  endDateTime,
}: UnavailableEvent) =>
  isEqual(endOfDay(new Date(endDateTime)), new Date(endDateTime)) &&
  isEqual(startOfDay(new Date(startDateTime)), new Date(startDateTime));
